import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentBadgeComponent } from './student-badge.component';
import { ParaMilestoneIconModule } from '../para-milestone-icon/para-milestone-icon.module';

@NgModule({
	imports: [CommonModule, ParaMilestoneIconModule],
	declarations: [StudentBadgeComponent],
	exports: [StudentBadgeComponent],
})
export class StudentBadgeModule {}

